import { apiClient } from "../api"
import { stringifyParams } from "../utils/api"
import { DTO_MaintenanceBase, DTO_MaintenanceMobile, DTO_ServiceBase, DTO_ServiceInstance, Entity_ServiceBase, Entity_ServiceInstance, MaintenanceBaseParams } from "./types/maintenance"

enum Maintenance {
  SYSTEM_MAINTENANCE = '/system/maintenance/',
  SYSTEM_SERVICE_INSTANCE = '/system/serviceinstance/',
  SYSTEM_SERVICE_BASE = '/system/servicebase/',
  SERVICE_ATTACHMENT = '/system/serviceinstanceattachments/'
}

export const getMaintenanceBase = (params: MaintenanceBaseParams): Promise<DTO_MaintenanceBase[]> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${Maintenance.SYSTEM_MAINTENANCE}?${queryStr}`)
    .then(res => res.data)
  return promise
}

export const getMaintenanceMobile = (id: number, useTimeInterval: boolean = false): Promise<DTO_MaintenanceMobile> => {
  const ac = apiClient()
  const promise = ac.get(`${Maintenance.SYSTEM_MAINTENANCE}${id}/get_grid/?calendar=${useTimeInterval}`)
    .then(res => res.data)
  return promise
}

export const getServiceInstance = (id?: number): Promise<DTO_ServiceInstance | DTO_ServiceInstance[]> => {
  const ac = apiClient()
  const promise = ac.get(`${Maintenance.SYSTEM_SERVICE_INSTANCE}${id ?? ''}`)
    .then(res => res.data)
  return promise
}

export const createServiceInstance = (data: Entity_ServiceInstance): Promise<DTO_ServiceInstance> => {
  const ac = apiClient()
  const promise = ac.post(Maintenance.SYSTEM_SERVICE_INSTANCE, data).then(res => res.data)
  return promise
}

export const updateServiceInstance = (id: number, data: Entity_ServiceInstance): Promise<DTO_ServiceInstance> => {
  const ac = apiClient()
  const promise = ac.patch(`${Maintenance.SYSTEM_SERVICE_INSTANCE}${id}/`, data).then(res => res.data)
  return promise
}

export const removeServiceInstance = (id: number): Promise<void> => {
  const ac = apiClient()
  const promise = ac.delete(`${Maintenance.SYSTEM_SERVICE_INSTANCE}${id}/`)
    .then(res => res.data)
  return promise
}

export const getServiceBase = (mobileid: number): Promise<DTO_ServiceBase[]> => {
  const ac = apiClient()
  const promise = ac.get(`${Maintenance.SYSTEM_SERVICE_BASE}${mobileid ? `?search=${mobileid}` : ''}`)
    .then(res => res.data)
  return promise
}

export const createServiceBase = (data: Entity_ServiceBase): Promise<DTO_ServiceBase> => {
  const ac = apiClient()
  const promise = ac.post(Maintenance.SYSTEM_SERVICE_BASE, data).then(res => res.data)
  return promise
}

export const updateServiceBase = (id: number, data: Entity_ServiceBase): Promise<DTO_ServiceBase> => {
  const ac = apiClient()
  const promise = ac.patch(`${Maintenance.SYSTEM_SERVICE_BASE}${id}/`, data).then(res => res.data)
  return promise
}

export const removeServiceBase = (id: number): Promise<void> => {
  const ac = apiClient()
  const promise = ac.delete(`${Maintenance.SYSTEM_SERVICE_BASE}${id}/`)
    .then(res => res.data)
  return promise
}

export const removeServiceInstanceAttachment = (id: number): Promise<void> => {
  const ac = apiClient()
  const promise = ac.delete(`${Maintenance.SERVICE_ATTACHMENT}${id}/`)
    .then(res => res.data)
  return promise
}
